import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaBars, FaUser } from 'react-icons/fa';
import { AiOutlineClose } from 'react-icons/ai';
import { SidebarData } from './SidebarData';

function Navbar() {
  const navigate = useNavigate();
  const [sidebar, setSidebar] = useState(false);
  const [hovered, setHovered] = useState(false); // Track hover state
  const [user, setUser] = useState(null);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const userMenuRef = useRef(null);

  useEffect(() => {
    const username = localStorage.getItem('username');
    if (username) setUser(username);
  }, []);

  const toggleSidebar = () => setSidebar(!sidebar);

  const handleLogout = () => {
    localStorage.removeItem('username');
    localStorage.removeItem('token');
    setUser(null);
    navigate('/');
  };

  const toggleSubMenu = (index) => {
    setActiveMenu(activeMenu === index ? null : index);
  };

  const handleClickOutside = (event) => {
    if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
      setShowUserMenu(false);
    }
  };

  useEffect(() => {
    if (showUserMenu) document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [showUserMenu]);

  return (
    <>
      {/* Navbar */}
      <nav className="bg-white p-5 shadow-md fixed w-full z-50">
        <div className="container mx-auto flex justify-between items-center">
          <div className="flex items-center">
            <button onClick={toggleSidebar} className="text-gray hover:text-gray-500 mr-4 ">
              <FaBars className="w-6 h-6" />
            </button>
            <div className="text-blue-900 text-xl font-bold ml-1">நித்ரா தமிழ் காலண்டர்</div>
          </div>
          {user ? (
            <div className="relative" ref={userMenuRef}>
              <button
                onClick={() => setShowUserMenu(!showUserMenu)}
                className="flex items-center space-x-2 text-gray-800"
              >
                <FaUser className="w-6 h-6" />
                <span>Welcome, {user}</span>
              </button>
              {showUserMenu && (
                <div className="absolute mt-2 bg-white text-gray-800 rounded-lg shadow-lg w-48">
                  <Link to="/MyAccount" className="block px-4 py-2 hover:bg-gray-200">My Account</Link>
                  <button
                  //  onClick={handleLogout}
                   className="block px-4 py-2 hover:bg-gray-200">Logout</button>
                </div>
              )}
            </div>
          ) : (
            <Link to="/" className="px-4 py-2 bg-white text-blue-500 rounded">Sign up</Link>
          )}
        </div>
      </nav>
{/* Sidebar */}
<div
  className={`fixed ${
    hovered ? 'w-64' : 'w-16'
  } h-screen bg-gradient-to-r from-gray-900 to-gray-900 transition-all duration-300 z-50 overflow-y-auto`}
  style={{ top: '69px', maxHeight: 'calc(100vh - 69px)', overflowY: 'auto' }} // Ensure max-height and overflow
  onMouseEnter={() => setHovered(true)}
  onMouseLeave={() => setHovered(false)}
>
  <div className="nav-menu-items w-full">
    <div className="w-full h-20 flex items-center">
      {hovered && (
        <button className="menu-bars ml-8 text-2xl text-white" onClick={toggleSidebar}>
          <AiOutlineClose />
        </button>
      )}
    </div>
    {SidebarData.map((item, index) => (
      <div key={index} className="nav-text flex flex-col">
        {item.subNav ? (
          <>
            <button
              className={`text-white flex items-center ${
                hovered ? 'px-4 py-2' : 'justify-center py-4'
              } hover:bg-blue-500 rounded-lg transition duration-300`}
              onClick={() => toggleSubMenu(index)}
            >
              {item.icon}
              {hovered && <span className="ml-4">{item.title}</span>}
            </button>
            {hovered && activeMenu === index && (
              <div className="ml-8">
                {item.subNav.map((subItem, subIndex) => (
                  <Link
                    key={subIndex}
                    to={subItem.path}
                    className="text-gray-300 block px-4 py-1 hover:bg-gray-600 rounded transition duration-300"
                    onClick={toggleSidebar}
                  >
                    {subItem.title}
                  </Link>
                ))}
              </div>
            )}
          </>
        ) : (
          <Link
            to={item.path}
            className={`text-white flex items-center ${
              hovered ? 'px-4 py-2' : 'justify-center py-4'
            } hover:bg-blue-500 rounded-lg transition duration-300`}
            onClick={toggleSidebar}
          >
            {item.icon}
            {hovered && <span className="ml-4">{item.title}</span>}
          </Link>
        )}
      </div>
    ))}
  </div>
</div>

    </>
  );
}

export default Navbar;
